<!--私有工作流定义
定义的是节点，每一个节点的负责人、操作项操作步骤，创建的时候作为模板，选择工作流的时候加载，然后可以修改编辑
-->
<template>
  <div class="newworkFlowDefine">
    <div class="set-left">
      <div class="set-title-top">
        <span class="set-title">私有工作流</span>
        <el-button type="primary" size="mini" @click="addFlow">新增</el-button>
      </div>
      <div v-show="false">
        <span v-for="(item,index) in flowList" :key="index"></span>
      </div>
      <el-scrollbar style="height:92%;width: 100%;">
        <div :class="['item',{'active':nowFlow == item}]" v-for="(item,index) in watchList" :key="index"
          @click="edit(item,index)">
          <div class="name" style="font-size:14px">{{item.name}}</div>
          <p class="memo" style="font-size:12px;margin-top:10px">{{getDate(item.createTime)}}</p>
          <div class="is-btn">
            <div class="set-caozuo">
              <div @click.stop="deleteFlow(item,index)" class="set-btns">
                <el-tooltip effect="dark" content="删除" placement="top">
                  <elIconBtn btnType='del'></elIconBtn>
                </el-tooltip>
              </div>
            </div>
          </div>
        </div>
      </el-scrollbar>
    </div>
    <div v-show="nowFlow != undefined" class="right-table">
      <!-- <button class="nomalButton" @click="backToList">退出到上一级</button> -->
      <div class="btn-top">
        <div class="Files-top">
          <div class="ic-left">
            <span>私有工作流定义</span>
          </div>
          <div class="btns">
            <el-button type="primary" @click="save" v-show="nowFlow != undefined && nowFlow.type == 'adding'"
              class="last-el-button">保存私有工作流</el-button>
            <el-button type="primary" @click="save" v-show="nowFlow != undefined && nowFlow.type != 'adding'"
              class="last-el-button">保存私有工作流</el-button>
          </div>
        </div>
        <div class="search-input-btn">
          <div class="input-small mr-20">
            <span>私有工作流名称（必填）：</span>
            <el-input v-model="orderTitle" placeholder="请输入工作流名称" disabled></el-input>
          </div>
          <div class="input-small">
            <span>分组：</span>
            <el-select v-model="nowOrderGroupnew" placeholder="请选择" @change="pickerOrderGroup_fn">
              <el-option v-for="item in orderGroupList" :key="item.id" :label="item.name" :value="item.id"> </el-option>
            </el-select>
          </div>
        </div>
      </div>


      <createNode ref="createNodeBean" :nowOrderGroup="nowOrderGroup" :nowFlow="nowTargetFlow" :isImport="isImport">
      </createNode>
    </div>
    <div v-show="nowFlow == undefined" class="right-table">
      <div class="btn-top"></div>
      <div class="bottom-table"></div>
    </div>
  </div>
</template>

<script>
  import listView from '@/components/module/selection/base/listView.vue';
  import scheduleAxis from '@/components/module/axis/scheduleAxis.vue';
  import treeSingleSelection from '@/components/module/selection/base/treeSingleSelection.vue';
  import createNode from '@/page/order/createOrder/newCreateNode.vue';
  import elIconBtn from '@/components/module/iconBtns.vue'
  export default {
    components: {
      listView,
      scheduleAxis,
      treeSingleSelection,
      createNode,
      elIconBtn
    },
    props: {},
    data () {
      return {
        nowFlow: undefined,
        flag: true,
        watchList: [{
          name: 1,
          next: [],
          type: 'adding',
          createTime: new Date().getTime()
        }],
        orderTitle: "1",
        isImport: false,
        delIndex: 0,
        nowOrderGroup: undefined,
        nowOrderGroupnew: "",
        // orderGroupList:[]
      };
    },

    mounted () {
      this.edit(this.watchList[0],0)
      if(this.orderGroupList.length!=0) {
        this.nowOrderGroup=this.orderGroupList[0]
        this.nowOrderGroupnew=this.orderGroupList[0].id
      }
    },
    destroyed () {},
    computed: {
      orderGroupList () {
        var data=this.$store.orderGroupStore.getters.getOrderGroupTree
        return data
      },
      flowList () {
        // this.watchList=this.$store.workFlowStore.getters.getFlowList(1)
        return this.$store.workFlowStore.getters.getFlowList(1);
      },
      nowTargetFlow () {
        if(this.nowFlow==undefined) {
          return {};
        }
        if(this.nowFlow.type=='adding') {
          return this.nowFlow;
        }
        if(this.nowFlow.flowId==undefined) {
          return {};
        }

        return this.$store.workFlowStore.getters.getFlowTreeByFlowId(this.nowFlow.flowId);
      },
      getDate () {
        return item => {
          return new Date(item).formatByTime();
        };
      }
    },
    watch: {
      watchList (val) {
        if(val.length!=0) {
          this.edit(val[0])
        }
      }
    },
    beforeDestroy () {

      // this.save(0)
      if(this.nowFlow) {
        this.flag=false
        this.save()
      }
    },
    methods: {
      pickerOrderGroup_fn (val) {
        var arr=this.orderGroupList.filter(item => item.id==val)
        this.nowOrderGroup=arr[0]
      },
      edit (flow,index) {
        this.flag=true
        this.nowFlow=flow;
        this.nowOrderGroupnew=this.nowFlow.groupId+''
        this.orderTitle=flow.name
        this.$refs.createNodeBean.getArchive=true;
        this.delIndex=index
      },
      addFlow () {
        //点击了新增工作流
        this.$dialogMethod.openNomalInputDialog(
          '创建工作流',
          [
            {
              name: '工作流名称',
              pkid: 'name',

            },
            {
              workTime: new Date().getTime(),
            },{
              workTime: new Date().getTime(),
            }
          ],
          respon => {
            this.nowFlow={
              name: respon.name,
              next: [],
              type: 'adding',

              createTime: new Date().getTime()
            };
            this.watchList.unshift(this.nowFlow)
            this.orderTitle=respon.name
          }
        );
      },
      save () {
        //提交到服务器
        var nodes=this.$refs.createNodeBean.getData();
        if(nodes.length==0) {
          this.$dialogMethod.showMessage('至少需要有一个节点!');
          return;
        }
        let archivesIds=[]

        for(var i=0,len=nodes.length;i<len;i++) {
          if(isempty(nodes[i].nodeUsers)) {
            this.$dialogMethod.showMessage('每个节点都必须有负责人!');
            return;
          }
          if(nodes[i].nodeType==2) {
            if(nodes[i].next.length!=0) {
              archivesIds=nodes[i].next.map(item => {
                return item.linkObject
              }).join(",")
            } else {

              archivesIds=nodes[i].archivesIds

            }
            nodes[i].archivesIds=copy(archivesIds)

          }
          if(isempty(nodes[i].archivesIds)&&nodes[i].nodeType==2) {
            this.$dialogMethod.showMessage('节点类型为“巡检”时必须选择台账设备!');
            return;
          }
          for(var i1=0,len1=nodes[i].next.length;i1<len1;i1++) {
            var item=nodes[i].next[i1]
            if(isempty(item.next)&&nodes[i].nodeType==0) {
              this.$dialogMethod.showMessage("操作项至少需要有一个操作步骤!")
              return
            }
          }
        }

        if(this.flag) {
          this.$dialogMethod.showLoading('正在保存');
        }
        if(this.nowFlow.type=='adding') {
          this.$api.flowApi.addFlow(this.orderTitle,1,JSON.stringify(nodes),this.nowOrderGroupnew,respon => {
            this.$store.workFlowStore.commit('getFlowList');
            if(this.flag) {
              this.$dialogMethod.showMessage('保存成功!');
            }
            this.$dialogMethod.closeLoading();
            //   this.nowFlow = undefined;
          });
        } else {
          this.$api.flowApi.updateFlow(this.nowFlow.flowId,this.orderTitle,1,JSON.stringify(nodes),this.nowOrderGroupnew,respon => {
            this.$store.workFlowStore.commit('getFlowList');
            if(this.flag) {
              this.$dialogMethod.showMessage('保存成功!');
            }
            this.$dialogMethod.closeLoading();
            //   this.nowFlow = undefined;
          });
        }
      },
      deleteFlow (row,index) {
        var flowId=this.nowFlow.flowId

        //删除工作流
        this.$confirm(`是否删除工作流 ${row.name}?`,'提示',{
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            if(flowId==undefined) {

              //  this.$store.workFlowStore.commit('getFlowList');
              this.watchList.splice(index,1)

              this.$message({message: "删除成功",type: 'success'});
            } else {
              this.$api.flowApi.deleteFlow(
                flowId,
                respon => {
                  if(respon=='删除成功') {
                    this.$message({
                      message: respon,
                      type: 'success'
                    });
                    this.$store.workFlowStore.commit('getFlowList');
                  }
                },
                err => {
                  this.$message({
                    message: err,
                    type: 'error'
                  });
                }
              );
            }

          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除'
            });
          });
      },
      backToList () {
        this.flag=false
        this.save()
        if(this.nowFlow.type=='adding') {
          //返回到工作流列表
          this.$dialogMethod.openAgreeDialog('退出编辑','所有的未保存操作将会丢失，是否继续？',respon => {
            this.nowFlow=undefined;
          });
        } else {
          this.nowFlow=undefined;
        }
      }
    }
  };
</script>

<style scoped lang="scss">
  .newworkFlowDefine {
    display: flex;

    .set-title-top {
      display: flex;
      justify-content: space-between;
      align-items: center;

      /deep/.el-button {
        margin-right: 0px !important;
        padding: 6px 11px;
      }


    }

    .set-left .item {
      position: relative;
    }

    .is-btn {
      position: absolute;
      top: 50%;
      transform: translateY(-70%);
      right: 10px;
      display: none;
    }

    .set-caozuo {
      display: flex;
    }

    .set-left .item:hover {
      color: #1a1a1a;

      .is-btn {
        display: block;
      }
    }

    .right-table {
      width: calc(100% - 275px);
      height: 100%;

      //  background-color: #fff;
      .btn-top {
        width: 100%;
        height: 142px;
        background-color: #fff;
        margin-bottom: 8px;
        padding: 12px 20px 20px 20px;
        box-sizing: border-box;
      }

      .search-input-btn {
        margin: 24px 0px 0px 0px;
      }
    }

    .bottom-table {
      height: calc(100% - 150px);
      background-color: #fff;
      overflow: hidden;
    }
  }
</style>